import { normalizeTierId } from '../config/PricingConfig'

type TimestampLike = { toMillis?: () => number; toDate?: () => Date }

const timestampMillis = (value: unknown): number | null => {
  if (!value) return null
  if (value instanceof Date) return value.getTime()
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  if (typeof value === 'string') {
    const parsed = Date.parse(value)
    return Number.isFinite(parsed) ? parsed : null
  }
  if (typeof value === 'object') {
    const timestamp = value as TimestampLike
    if (typeof timestamp.toMillis === 'function') return timestamp.toMillis()
    if (typeof timestamp.toDate === 'function') return timestamp.toDate().getTime()
  }
  return null
}

export const isWorkspaceSubscriptionRestricted = (
  workspace: { plan?: unknown; subscription?: unknown } | Record<string, unknown> | null | undefined,
  now = Date.now()
) => {
  const plan = normalizeTierId(workspace?.plan)
  if (plan === 'FREE_TIER') return false
  const subscription = workspace?.subscription && typeof workspace.subscription === 'object'
    ? workspace.subscription as Record<string, unknown>
    : null
  if (!subscription) return true
  if (subscription.status !== 'ACTIVE') return true
  const periodEnd = timestampMillis(subscription.periodEnd)
  return typeof periodEnd === 'number' && periodEnd < now
}
